import {CountryCode} from "../reducers/ticket";

export function getModalStyle() {
  return {
    modal: { backgroundColor: "#f2f2f2" },
    closeIcon: { backgroundColor: "red", fill: "white" },
  };
}

export const prepareGiroCodeData = (
  bic: string,
  businessName: string,
  ibanInQR: string,
  currency: string | undefined,
  totalAmount: string,
  ticketNumber: string
): string => {
  return [
    "BCD",
    "002",
    "1",
    "SCT",
    bic,
    businessName,
    ibanInQR,
    `${currency}${totalAmount}`,
    "",
    ticketNumber,
    "",
    ""
  ].join("\n");
};

export const beppoCompanies: Record<CountryCode, {
    iban: string;
    ibanText: string;
    ibanSocar: string;
    ibanSocarText: string;
    businessName: string;
    streetName: string;
    streetNumber: string;
    postalCode: string;
    townName: string;
    country: string;
    bic: string;
    bank: string;
}> = {
    [CountryCode.CH]: {
        iban: "CH2300700114806625483",
        ibanText: "CH23 0070 0114 8066 2548 3",
        ibanSocar: "CH4400700114808178948",
        ibanSocarText: "CH44 0070 0114 8081 7894 8",
        businessName: "beppo AG",
        streetName: "Badenerstrasse",
        streetNumber: "549",
        postalCode: "8048",
        townName: "Zürich",
        country: "CH",
        bic: "ZKBKCHZZ80A",
        bank: "ZKB"
    },
    [CountryCode.DE]: {
        iban: "DE33651915000543674029",
        ibanText: "DE33 6519 1500 0543 6740 29",
        ibanSocar: "DE83651915000543674002",
        ibanSocarText: "DE83 6519 1500 0543 6740 02",
        businessName: "beppo GmbH",
        streetName: "Wollmatinger Strasse",
        streetNumber: "70",
        postalCode: "78467",
        townName: "Konstanz",
        country: "DE",
        bic: "GENODES1TET",
        bank: "Volksbank Bodensee-Oberschwaben"
    },
    [CountryCode.AT]: {
            iban: "AT322060200000660225",
            ibanText: "AT32 2060 2000 0066 0225",
            ibanSocar: "AT762060200000660209",
            ibanSocarText: "AT76 2060 2000 0066 0209",
            businessName: "beppo GmbH",
            streetName: "Schillerstrasse",
            streetNumber: "22",
            postalCode: "6890",
            townName: "Lustenau",
            country: "AT",
            bic: "DOSPAT2DXXX",
            bank: "DORNBIRNER SPARKASSE BANK AG"
        }
};



